import React from "react";
import { useHandlers } from "./hooks";
import { ProductDeleteModal } from "./components";
import { TrashIcon } from "../../../../../../../../../../components/Icons";
import "./index.scss";

/**
 * @desc Delete a product for self service form.
 */
export const ProductDelete = ({ product }) => {
  // HANDLERS -----------------------------------------------------------------

  const { handleClick } = useHandlers({ product });

  // COMPONENT ----------------------------------------------------------------

  return (
    <>
      <ProductDeleteModal product={product} />
      <button className="product-delete" onClick={handleClick}>
        <TrashIcon width={37} height={43} />
      </button>
    </>
  );
};
